<template>
  <v-col cols="12">
    <div class="tech-card">
      <div class="d-flex align-center justify-center mb-6">
        <!--
          Icon using Vuetify's v-icon component.
          An icon representing partnership or strength.
        -->
        <v-icon
          color="blue-accent-3"
          class="mr-3"
          size="100"
        >
          mdi-handshake
        </v-icon>
        
        <!--
          Title with a bold, clean style.
        -->
        <h2 class="text-h5 text-sm-h4 text-md-h3 font-weight-bold mb-3 mb-md-4 white--text">
          Trusted by Industry Leaders
        </h2>
      </div>

      <div
        class="d-flex justify-center align-center pa-8"
        style="min-height: 140px;"
      >
        <h2 class="text-h5 text-sm-h4 text-md-h3 font-weight-bold mb-3 mb-md-4 text-black text-center typewriter">
          <VueTypical
            :steps="partners"
            :loop="Infinity"
            :wrapper="'span'"
            :type-speed="80"
            :delete-speed="100"
          />
        </h2>
      </div>
    </div>
  </v-col>
</template>

<script setup>
import { ref } from 'vue';
import VueTypical from 'vue-typical';

const partners = ref([
  "Nightwing", 1000,
  "Visionist Inc.", 1000,
  "Boeing", 1000,
  "TransTechSol", 1000,
  "Peraton", 1000,
  "Lockheed Martin", 1000
]);
</script>

<style scoped>
.typewriter {
  font-family: 'Courier New', Courier, monospace;
}
</style>